import React from 'react'
import styled from 'styled-components'
import css from '@styled-system/css'
import { NavLink } from 'react-router-dom'
import Icon from '../Icon'
import Box from '../Box'

const StyledIcon = styled(Icon)(
  css({
    opacity: '0.3',
    '.active &, &:hover': {
      opacity: '1',
      color: 'nav.hover',
    },
  }),
)

const StyledBox = styled(Box)(
  css({
    boxSizing: 'border-box',
    borderLeft: '4px solid',
    borderColor: 'transparent',
    '.active &': {
      borderColor: 'primary.0',
    },
  }),
)

export default function SideNavLink({ isOpen, icon, label, ...props }) {
  return (
    <NavLink activeClassName="active" {...props}>
      <StyledBox px="large" py="medium" mb="large">
        <Box display="flex" alignItems="center">
          <StyledIcon color="background.0" size="medium" name={icon} />
        </Box>
      </StyledBox>
    </NavLink>
  )
}
